import React from 'react'
import styled from 'styled-components'

const StyledH1 = styled.h1`
  font-size: 16pt;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 40px;
  text-align: left;
  margin-bottom: 5px;
`

const ContextPaneTitle = props => {
  return <StyledH1>{props.elementTitle}</StyledH1>
}

export default ContextPaneTitle
